import React, { useCallback } from 'react';
import Image from 'next/image';
import { LandingPageFeature } from '@/shared/types/landing-page';
import './index.less';

export default function Feature({ feature, onClick }: { feature: LandingPageFeature; onClick?: () => void }) {
  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <div className="feature">
      <div className="img-box">
        <Image
          src={feature.image}
          width={800}
          height={820}
          sizes="((min-width: 320px) and (max-width: 700px)) calc(100vw - 64px), ((min-width: 700px) and (max-width: 1160px)) calc(50vw - 64px), (min-width: 1160px) 500px, calc(100vw - 64px)"
          alt="Membership feature"
          title="Membership feature"
        />
      </div>
      <div className="text-box">
        <h2 className="title">{feature.title}</h2>
        {feature.description && <span className="desc">{feature.description}</span>}
        {feature.buttonText && (
          <span className="action-button learn-more-btn" onClick={handleClick}>
            {feature.buttonText}
          </span>
        )}
        {feature?.dicountText && (
          <span className="discount-text">
            <span>{feature.dicountText}</span>
          </span>
        )}
      </div>
    </div>
  );
}
